import styled from '@emotion/styled';

import { Dropdown, IconButton, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import type { ForwardDropdownProps } from '@hotjar/webapp/features/Forwarding/ForwardDropdown';
import { ForwardDropdown } from '@hotjar/webapp/features/Forwarding/ForwardDropdown';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

const DropdownWithoutPadding = styled(Dropdown)`
  .tippy-content {
    padding: ${tokens.spacer.x1} 0;
  }
`;

export const ForwardResults = (props: ForwardDropdownProps): JSX.Element => {
  const { trackingUiPosition, trackingState } = props;
  const { click: trackClick } = useTrack();
  const { t } = useTranslation('feedback', { keyPrefix: 'common.responses-list' });

  const track = () => {
    if (trackingUiPosition !== undefined) {
      trackClick('Forward Icon', trackingUiPosition, {
        state_event_was_triggered_on: trackingState,
      });
    }
  };

  return (
    <DropdownWithoutPadding
      onTrigger={track}
      trigger={
        <IconButton
          size="s"
          kind="ghost"
          icon="forward"
          description={t('forward-results')}
          tooltipText={t('forward')}
        />
      }
    >
      <ForwardDropdown {...props} />
    </DropdownWithoutPadding>
  );
};
